import { useTranslations } from '@vocab/react';
import { Loader, Stack, Text } from 'braid-design-system';

import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { SALARY } from 'src/components/Router';
import { NEXT_ROLE_SALARY_FORM } from 'src/context/FormContext';

import { LocationGroupSubtitle } from '../../ReadNextRole/LocationGroupSubtitle/LocationGroupSubtitle';
import { NextRoleDetail } from '../../ReadNextRole/NextRoleDetail/NextRoleDetail';
import { NextRoleSection } from '../../types';
import { EditSalary } from '../EditSalary/EditSalary';
import { useSalaryPreferences } from '../data';

import translations from './.vocab';

export const ReadSalary = () => {
  const { t } = useTranslations(translations);
  const { salaryPreferences, error } = useSalaryPreferences();
  const hasMultipleSalaryPreferences = salaryPreferences.length >= 2;

  return (
    <>
      <NextRoleDetail
        title={t('Salary expectation')}
        section={NextRoleSection.salary}
        overrideAddButton={
          error
            ? false
            : salaryPreferences.filter(
                (salaryPreference) => salaryPreference.description !== null,
              ).length === 0
        }
      >
        {error ? (
          <Loader data={{ automation: 'salary-loading' }} />
        ) : (
          salaryPreferences.length > 0 && (
            <Stack space="medium" component="ul">
              {salaryPreferences.map((salaryItem) => {
                const hasDescription = salaryItem.description !== null;
                const tone = !hasDescription ? 'secondary' : 'neutral';

                return (
                  <Stack
                    component="li"
                    key={`salary-${salaryItem.id}`}
                    space="small"
                  >
                    {hasMultipleSalaryPreferences && (
                      <LocationGroupSubtitle
                        countryCode={salaryItem.country.countryCode}
                      />
                    )}
                    <Text tone={tone}>
                      {salaryItem?.description || t('Not specified')}
                    </Text>
                  </Stack>
                );
              })}
            </Stack>
          )
        )}
      </NextRoleDetail>
      <FormDrawer
        title={t('Salary expectation')}
        component={EditSalary}
        card={SALARY}
        description={t(
          'Your expected base salary will help you to be found by relevant employers.',
        )}
        formName={NEXT_ROLE_SALARY_FORM}
      />
    </>
  );
};
